import axios from 'axios';
import { ensureProtocol } from '../config/backend';

function getBase() {
  return ensureProtocol(localStorage.getItem('ipBackend2') || '');
}

function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token } : {};
}

/** Opções ausentes em backends antigos — espelham Tacoma_Backend_Analista/routes/permissoesSidebar.js */
const OPCOES_FALLBACK = [
  { codigo: 'RELATORIOS_CHAMADOS_ABERTOS', nome: 'Relatórios → Chamados em aberto (Excel)' },
  { codigo: 'RELATORIOS_TEMPO_COLABORADOR', nome: 'Relatórios → Por colaborador (horas)' },
  { codigo: 'RELATORIOS_EMPRESA', nome: 'Relatórios → Atendimento por empresa' },
  { codigo: 'REPOSITORIOS', nome: 'Desenvolvimento (bloco)' },
  { codigo: 'REPOSITORIOS_LISTA', nome: 'Desenvolvimento → Repositórios' },
  { codigo: 'WORKLOG', nome: 'Horas & Faturamento (bloco)' },
  { codigo: 'WORKLOG_TIMESHEET', nome: 'Horas & Faturamento → Timesheet' },
  { codigo: 'WORKLOG_FATURAMENTO', nome: 'Horas & Faturamento → Faturamento' },
  { codigo: 'WORKLOG_TARIFAS', nome: 'Horas & Faturamento → Tarifas' },
  { codigo: 'CONFIG_SISTEMA', nome: 'Config → Configurações do sistema' },
  { codigo: 'CONFIG_PERMISSOES_USUARIO', nome: 'Config → Permissões do menu por usuário' },
  { codigo: 'MANUTENCAO_DOCUMENTAR', nome: 'Inventário → Documentar manutenção' },
  { codigo: 'MANUTENCAO_HISTORICO', nome: 'Inventário → Histórico de hardware' },
  { codigo: 'AUTOMACAO', nome: 'Config → Regras de automação' },
];

export async function fetchOpcoesSidebar() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/permissoes-sidebar/opcoes', { headers: getAuthHeaders(), timeout: 10000 });
    const lista = Array.isArray(res?.data) ? res.data : [];
    const codigos = new Set(lista.map((o) => (o.codigo || '')));
    const extras = OPCOES_FALLBACK.filter((o) => !codigos.has(o.codigo));
    return extras.length ? [...lista, ...extras] : lista;
  } catch (err) {
    console.error('Erro ao listar opções do sidebar:', err);
    return [];
  }
}

export async function fetchMinhasPermissoes() {
  const base = getBase();
  if (!base) return null;
  try {
    const res = await axios.get(base + '/permissoes-sidebar/me', {
      headers: getAuthHeaders(),
      timeout: 10000,
      params: { _t: Date.now() },
    });
    return res?.data && typeof res.data === 'object' ? res.data : null;
  } catch (err) {
    console.error('Erro ao carregar permissões do sidebar:', err);
    return null;
  }
}

export async function fetchPermissoesUsuario(usuarioId) {
  const base = getBase();
  if (!base || !usuarioId) return null;
  try {
    const res = await axios.get(base + '/permissoes-sidebar/usuarios/' + usuarioId, { headers: getAuthHeaders(), timeout: 10000 });
    return res?.data && typeof res.data === 'object' ? res.data : null;
  } catch (err) {
    console.error('Erro ao carregar permissões do usuário:', err);
    return null;
  }
}

export async function putPermissoesUsuario(usuarioId, permissoes) {
  const base = getBase();
  if (!base || !usuarioId) throw new Error('Backend ou usuário não definido');
  const res = await axios.put(base + '/permissoes-sidebar/usuarios/' + usuarioId, { permissoes }, { headers: getAuthHeaders() });
  return res?.data;
}
